const inplappwebview = 'inplappwebview';

export const getFlagFromQueryParam = (): boolean | undefined => {
  if (typeof window === 'undefined') return;
  const param = new URLSearchParams(window.location.search).get(inplappwebview);
  return param === 'true' ? true : param === 'false' ? false : undefined;
};

export const getInplAppWebviewFlag = (): boolean | undefined => {
  const flagFromQuery = getFlagFromQueryParam();
  return flagFromQuery;
};
